import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInAnonymously,
  signInWithPopup,
  signOut,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyA3FyreEn5kuKehB4c7huXA8lkbWWXxd0c',
  authDomain: 'cometchatteammessanger.firebaseapp.com',
  projectId: 'cometchatteammessanger',
  storageBucket: 'cometchatteammessanger.firebasestorage.app',
  messagingSenderId: '950141434859',
  appId: '1:950141434859:web:aaanfrsbgqd9noso8hkivsd8kcv1j5ac',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Firebase auth methods
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const signInAnonymouslyFirebase = () => signInAnonymously(auth);
export const signOutFirebase = () => signOut(auth);
